export const DashboardUnselected = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <g data-name="Group 7042">
            <g data-name="Group 18">
                <path data-name="Rectangle 31" fill="none" d="M0 0h24v24H0z" />
            </g>
            <g fill="#98a0ac">
                <path
                    data-name="Path 3339"
                    d="M11.66 5.641A1.642 1.642 0 0 0 10.019 4H5.642a1.642 1.642 0 0 0-1.641 1.641v6.565a1.642 1.642 0 0 0 1.641 1.641h4.376a1.642 1.642 0 0 0 1.641-1.641Zm-1.094 0v6.565a.548.548 0 0 1-.548.547H5.642a.548.548 0 0 1-.548-.547V5.641a.548.548 0 0 1 .548-.547h4.376a.548.548 0 0 1 .548.547Z"
                />
                <path
                    data-name="Path 3340"
                    d="M11.66 16.452a1.642 1.642 0 0 0-1.641-1.641H5.642a1.642 1.642 0 0 0-1.641 1.641v2.188a1.642 1.642 0 0 0 1.641 1.641h4.376a1.642 1.642 0 0 0 1.641-1.641Zm-1.094 0v2.188a.548.548 0 0 1-.548.547H5.642a.548.548 0 0 1-.548-.547v-2.188a.548.548 0 0 1 .548-.547h4.376a.548.548 0 0 1 .548.547Z"
                />
                <path
                    data-name="Path 3341"
                    d="M20.283 5.627A1.635 1.635 0 0 0 18.642 4h-4.376a1.635 1.635 0 0 0-1.641 1.627v13.027a1.635 1.635 0 0 0 1.641 1.627h4.376a1.635 1.635 0 0 0 1.641-1.627Zm-1.094 0v13.027a.545.545 0 0 1-.548.542h-4.376a.545.545 0 0 1-.548-.542V5.627a.545.545 0 0 1 .548-.542h4.376a.545.545 0 0 1 .548.542Z"
                />
            </g>
        </g>
    </svg>
)